import { render } from "./ProjectFileContentDocuments.vue?vue&type=template&id=bf65bc66&scoped=true"
import script from "./ProjectFileContentDocuments.vue?vue&type=script&lang=js"
export * from "./ProjectFileContentDocuments.vue?vue&type=script&lang=js"

import "./ProjectFileContentDocuments.vue?vue&type=style&index=0&id=bf65bc66&lang=scss&scoped=true"

import exportComponent from "/Users/mateuszsalamonski/WebstormProjects/ems_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf65bc66"]])

export default __exports__